// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty[data-v-70837b90] {\n  padding-top: 1.01333rem;\n}\n.empty img[data-v-70837b90] {\n  width: 3.89333rem;\n  height: 3.89333rem;\n  display: block;\n  margin: 0 auto;\n}\n.empty p[data-v-70837b90] {\n  text-align: center;\n  font-size: 0.37333rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n", ""]);
// Exports
module.exports = exports;
